import React from "react";
import { BaseModal } from "./FormElements/BaseModal";
import { InputField } from "./FormElements/InputField";
import { InputSelect } from "./FormElements/InputSelect";
import Button from "./FormElements/Button";
import { useFormRVEO } from "./hooks/useFormRVEO";
import { useForm } from "react-hook-form";
import { DualRing } from "react-loading-io";
import moment from "moment";
import {
  validatorFecha,
  validatorField
} from "../Utils/validators";
import ErrorCustom from "./errorCustom";

interface IModalFormBeneficiarie {
  open: boolean;
  selectedSisco: any;
  handleLoading: any;
  onSubmit: any;
  close: any;
}

export const ModalSiscoForm = ({
  open,
  selectedSisco,
  onSubmit,
  close
}: IModalFormBeneficiarie) => {

   const {
      handleSubmit,
      register,
      errors,
      getValues,
      setError,
      clearError,
      setValue,
      watch,
      formState
    } = useForm();

  return (
    <BaseModal
      open={open}
      handleClose={close}
      title="Seguro Previsional"
      width={`${window.innerWidth}px`}
    >
      <form
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
        onSubmit={handleSubmit(onSubmit)}
        className="p-0 formSisco"
      >
        <div>
          <InputField
            defaultValue={selectedSisco ? selectedSisco.contractName : ""}
            placeHolder="Nombre de contrato"
            disabled={selectedSisco}
            register={register({validate: (value) => validatorField(value)})}
            name="contractName"
          />
          <ErrorCustom errors={errors} name="contractName" />
        </div>
        <div>
          <InputField
          defaultValue={selectedSisco ? moment.unix(selectedSisco.startDate).format('DD/MM/YYYY') : ""}
          placeHolder="Fecha inicio"
          register={register({validate: (value) => validatorFecha(value)})}
          name="startDate"
          />
          <ErrorCustom errors={errors} name="startDate" />
        </div>
        <div>
          <InputField
            defaultValue={selectedSisco ? moment.unix(selectedSisco.endDate).format('DD/MM/YYYY') : ""}
            placeHolder="Fecha fin"
            register={register({validate: (value) => validatorFecha(value)})}
            name="endDate"
          />
          <ErrorCustom errors={errors} name="endDate" />
        </div>
        <div>
            <Button disabled={!formState.dirty && !formState.isValid } className="btn is-medium" type="submit">
              Guardar
            </Button>
        </div>
      </form>
    </BaseModal>
  );
};
